import axios from 'axios';
import { getMVToken, getToken } from '@/helpers/auth';
import { useState, useCallback } from 'react';

const useAxiosPost = () => {
  const [ loadingPostData, setLoadingPostData ] = useState(false);
  const [ error, setError ] = useState(null);
  const [ data, setData ] = useState(null);
  const [ status, setStatus ] = useState('');

  const sendRequest = useCallback(async (method, url, requestData, source = '') => {
    setLoadingPostData(true);
    try {
      const isFormData = requestData && requestData instanceof FormData;

      if (source === 'MV') {
        axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL_MAVERICK;
        let tokenMV = getMVToken();
        if (tokenMV) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${tokenMV}`;
          if (isFormData) {
            delete axios.defaults.headers.common['Content-Type'];
          } else {
            axios.defaults.headers.common['Content-Type'] = 'application/json';
          }
        }
      } else {
        if (getToken()) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${getToken()}`;
          if (isFormData) {
            delete axios.defaults.headers.common['Content-Type'];
          } else {
            axios.defaults.headers.common['Content-Type'] = 'application/json';
          }
        }
        axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
      }
      const response = await axios[method](url, requestData);

      setData(response.data);
      setStatus(response.status);
      return response.data;
    } catch (err) {
      setError(err.response?.data);
      // `data` deliberately keeps its previous value for callers that render through it; callers
      // that must not show a stale result should use the returned value instead.
      return null;
    } finally {
      setLoadingPostData(false);
    }
  }, []);

  return {
    loadingPostData,
    error,
    data,
    sendRequest,
    status,
  };
};

export default useAxiosPost;
